// Marketing mirror of the LIVE catalog (/billing/plan ← products/diwa/entitlements.py).
// The in-app /pricing page is live-fed; keep this static landing copy in sync with pricing_v1.md.
// Used by the landing page (/domicile) and the in-app Plan page (/pricing).

export interface Tier {
  key: string
  name: string
  price: string
  interval: string
  tagline: string
  features: string[]
  bestFit: string
  highlight?: boolean
}

export const TIERS: Tier[] = [
  {
    key: 'keeper', name: 'Keeper', price: '$0', interval: 'mo',
    tagline: 'You and your first domains: a private world, free.',
    features: ['5 domains', 'Open springs (press, AniList, news, health)', '15 missions on us · unlimited BYOK', '✦ Tala answers & drafts', 'Bring 3 of your own agents'],
    bestFit: 'Start here',
  },
  {
    key: 'keeper_plus', name: 'Keeper Plus', price: '$29', interval: 'mo',
    tagline: 'The serious solo system: govcon springs, full missions, sharing.',
    features: ['15 domains', '+ Curated springs (SAM, NAICS, awards)', '50 missions incl. bid/no-bid · unlimited BYOK', 'Shared domains', '8 principals · BYO agents'],
    bestFit: 'Serious individuals',
  },
  {
    key: 'operator', name: 'Operator', price: '$49', interval: 'mo',
    tagline: 'The power system: LinkedIn enrichment and high volume.',
    features: ['40 domains', '+ LinkedIn enrichment (your session)', '200 missions · unlimited BYOK', 'Shared domains · 25 principals', 'Everything in Keeper Plus'],
    bestFit: 'Power users & solo govcon',
    highlight: true,
  },
  {
    key: 'studio', name: 'Studio', price: '$99', interval: 'mo',
    tagline: 'Teams and volume: roles, seats, paid sources, showcases.',
    features: ['Unlimited domains', '+ Paid sources (news, company APIs)', '600 pooled missions · unlimited BYOK', 'Shared domains with roles · publish', 'Per-seat · +$25/seat'],
    bestFit: 'Teams & firms',
  },
  {
    key: 'sovereign', name: 'Sovereign', price: 'Custom', interval: '',
    tagline: 'Dedicated builds: own deployment, custom springs, governance.',
    features: ['Everything unlimited', 'Dedicated deployment', 'Custom springs & governance', 'White-label', 'Hand-negotiated'],
    bestFit: 'Private deployment',
  },
]